export default __webpack_public_path__ + "static/media/nft-7.7f9884da.png";